import {
  REPLACEMENT_PRODUCT_CODE_KEY,
  REPLACEMENT_PRODUCT_CODENTIFY_KEY
} from './constants'

export const getReplacementProductCode = (): string | null => {
  if (typeof window === 'undefined') {
    return null
  }
  try {
    return sessionStorage.getItem(REPLACEMENT_PRODUCT_CODE_KEY)
  } catch {
    return null
  }
}

export const getReplacementSerialNumber = (): string | null => {
  if (typeof window === 'undefined') {
    return null
  }
  try {
    return sessionStorage.getItem(REPLACEMENT_PRODUCT_CODENTIFY_KEY)
  } catch {
    return null
  }
}
